import { DecimalPipe } from '@angular/common'
import { Input, OnDestroy, OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { CellRangeEventArgs, FlexGrid } from '@grapecity/wijmo.grid'

@Component({
    selector: 'grid-selection-calculation',
    templateUrl: './grid-selection-calculation.component.html',
    styleUrls: ['./grid-selection-calculation.component.css'],
    standalone: true,
    imports: [DecimalPipe],
})
export class GridSelectionCalculationComponent implements OnInit, OnDestroy {
    @Input() grid!: FlexGrid
    total = 0
    average = 0
    min = 0
    max = 0
    count = 0

    ngOnInit() {
        this.grid.selectionChanged.addHandler(this.selectionChanged.bind(this))
    }

    ngOnDestroy() {
        this.grid.selectionChanged.removeAllHandlers()
    }

    selectionChanged(grid: FlexGrid, args: CellRangeEventArgs) {
        this.total = 0
        this.average = 0
        this.count = 0
        this.min = 0
        this.max = 0
        const rng = args.range
        if (rng.col >= 0 && rng.row >= 0) {
            let col = Math.min(rng.col, rng.col2)
            const col2 = Math.max(rng.col, rng.col2)
            const startRow = Math.min(rng.row, rng.row2)
            const row2 = Math.max(rng.row, rng.row2)
            let total = 0
            let count = 0
            const values: any[] = []

            for (col; col <= col2; col++) {
                let row = startRow
                for (row; row <= row2; row++) {
                    let value
                    if (grid.columns[col]._binding._parts.length === 1) {
                        value = grid.rows[row].dataItem[grid.columns[col]._binding._parts[0]]
                    }
                    if (grid.columns[col]._binding._parts.length === 2) {
                        value = grid.rows[row].dataItem[grid.columns[col]._binding._parts[0]][grid.columns[col]._binding._parts[1]]
                    }
                    if (grid.columns[col]._binding._parts.length === 3) {
                        value =
                            grid.rows[row].dataItem[grid.columns[col]._binding._parts[0]][grid.columns[col]._binding._parts[1]][
                                grid.columns[col]._binding._parts[2]
                            ]
                    }
                    const parsedValue = parseFloat(value)
                    //if (!isNaN(parsedValue) && parsedValue > 0) { // We could exluded zeros in the average.
                    if (!isNaN(parsedValue)) {
                        count++
                        total += parsedValue
                        values.push(parsedValue)
                    }
                }
            }

            this.total = total
            this.average = count != 0 ? total / count : 0
            this.count = count
            this.min = values.length == 0 ? 0 : Math.min(...values)
            this.max = values.length == 0 ? 0 : Math.max(...values)
        }
    }
}
